import type { CapabilityErrorUnion } from '../capabilityError';
import { makeCapabilityErrors } from '../capabilityError';

export const ProductListingError = makeCapabilityErrors('ProductListing');

export type ProductListingError = CapabilityErrorUnion<typeof ProductListingError>;
